import {
  handleTextMessageShowContext,
  handleLiveImageMessageShowContext,
  handleLiveFileMessageShowContext,
} from "@saas/components/src/utils/im/message-format";
// 二次处理消息信息
export function handleMessageData(message) {
  if (message.type === "custom") {
    //自定义消息
    const { data, extension } = message.payload;
    if (
      extension === "MGMaterialFileExt" ||
      (data && JSON.parse(data).msg_source === 1)
    ) {
      // 素材中心-文件消息
      const { url_path, file_size, file_name, file_uuid } = JSON.parse(data);
      message.payload = {
        fileUrl: url_path,
        uuid: file_uuid,
        fileName: file_name,
        fileSize: file_size,
        sourse: "material",
      };
      if (!message.showContext) {
        message.showContext = handleLiveFileMessageShowContext(
          message.payload,
          message
        );
      }
      message.type = "file";
    }
  } else if (message.type === "text") {
    if (!message.showContext) {
      message.showContext = handleTextMessageShowContext(
        message.payload?.text || ""
      );
    }
  } else if (message.type === "file") {
    // if (!message.showContext) {
    message.showContext = handleLiveFileMessageShowContext(
      message.payload,
      message
    );
    // }
  } else if (message.type === "image") {
    if (!message.showContext) {
      message.showContext = handleLiveImageMessageShowContext(
        message.payload?.imageInfoArray?.[0]
      );
    }
  }
  // 云端自定义数据
  if (message.cloudCustomData) {
    message.cloudCustomData = JSON.parse(message.cloudCustomData);
    message = {
      ...message,
      ...message.cloudCustomData,
    };
  }
  return message;
}

// 转换后端消息格式为IM消息格式
export function convertToIMMessage(item, userInfo) {
  // 根据消息类型转换
  const messageType = parseInt(item.message_type);
  let type = "text";
  let payload = {};

  // 根据message_type判断消息类型
  //  1文字 2图片 3表情 4语音 5文件 6自定义 7视频文件
  switch (messageType) {
    case 1: // 文本
      type = "text";
      payload = { text: item.message };
      break;
    case 2: // 图片
      type = "image";
      const { height, width, size } = item.image_info;
      payload = {
        uuid: item.file_uuid,
        imageInfoArray: [
          {
            url: item.message,
            imageUrl: item.message,
            height,
            width,
            size,
          },
        ],
      };
      break;
    case 5: // 文件
      type = "file";
      payload = {
        fileName: item.file_name,
        fileSize: item.file_size,
        fileUrl: item.message,
        uuid: item.file_uuid,
      };
      break;
    case 6: // 自定义消息
      type = "custom";
      if (item.msg_source) {
        //素材库
        payload = {
          extension: "MGMaterialFileExt",
          data: JSON.stringify({
            url_path: item.message,
            file_size: item.file_size,
            file_name: item.file_name,
            file_uuid: item.file_uuid,
          }),
        };
      }
      break;
    default:
      break;
  }

  // 构建IM消息格式
  const IMMessage = {
    ID: item.im_msg_id || item.im_msg_key || item.id,
    sequence: item.im_msg_seq,
    avatar: item.avatar,
    type,
    payload,
    from: item.user_id,
    to: item.to_user_id,
    flow: item.user_id === userInfo?.user_id ? "out" : "in",
    time: item.send_at,
    status: "success",
    cloudCustomData: item.cloud_custom_data || "",
    nick: item.nickname,
    message_client_time: item.send_at,
  };
  return handleMessageData(IMMessage);
}
